import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography, List, ListItem } from "@mui/material";
import Footer from "../../Components/Footer";
import CallToEnroll from "../../Components/CallToEnroll";
import AdmissionProcessBanner from "../../assets/AdmissionProcess.png";
import PageTitle from "../../Components/PageTitle";

const AdmissionProcess = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Admission Process - Shree Mangalam School"
        description="Learn about the step-by-step admission process at Shree Mangalam School for RIMC, Sainik School, and Military School coaching programs. Apply with ease and clarity."
        url="/admission-process"
        keywords="admission process, school admission, apply for coaching, RIMC admission, Sainik School application, Shree Manglam admission details"
      />

      <Header image={AdmissionProcessBanner} alt={"Shree Mangalam School"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Admission Process
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Welcome to Shree Mangalam School – where every child's
          educational journey begins with care, clarity, and commitment.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We are excited to welcome new students and their families into our
          learning community. Our admission process is simple, transparent, and
          designed to help parents and students feel confident at every step.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Who Can Apply?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We invite applications from students across, jaipur-gudha state highway (Just on by pass) gudha gorji,
          Jhunjhunu, and nearby regions. Admissions are open for classes Nursery
          to 10th, subject to seat availability and entrance assessment (if
          applicable).
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          <strong>Step-by-Step Admission Process</strong>
        </Typography>

        {/* Step 1 */}
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          1. Inquiry & Campus Visit
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Visit our campus, meet the admission counselor, explore facilities,
          and collect the prospectus or download it from our website.
        </Typography>

        {/* Step 2 */}
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          2. Submission of Admission Form
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Fill out and submit the form along with documents. A nominal
          registration fee may apply.
        </Typography>

        {/* Step 3 */}
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          3. Interaction / Entrance Test
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Informal interaction for lower classes. Written test for higher
          classes based on the previous class syllabus.
        </Typography>

        {/* Step 4 */}
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          4. Document Verification
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Required documents include:
        </Typography>
        <List sx={{ pl: 3 }}>
          <ListItem>• Birth Certificate</ListItem>
          <ListItem>• Transfer Certificate (TC)</ListItem>
          <ListItem>• Previous Year’s Report Card</ListItem>
          <ListItem>• Passport-size Photos (Student & Parents)</ListItem>
          <ListItem>• Aadhaar Cards (Student & Parents/Guardians)</ListItem>
        </List>

        {/* Step 5 */}
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          5. Admission Confirmation & Fee Payment
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          If selected, parents must confirm admission by submitting the
          admission and tuition fees within the specified timeframe.
        </Typography>

        {/* Step 6 */}
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          6. Welcome Kit & Orientation
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Students will receive:
        </Typography>
        <List sx={{ pl: 3 }}>
          <ListItem>• School ID Card</ListItem>
          <ListItem>• Books and Uniform Details</ListItem>
          <ListItem>• Orientation Schedule</ListItem>
        </List>

        {/* Step 7 */}
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          7. First Day of School
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            mb: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Begin the academic journey with confidence. Our staff and teachers
          will ensure a smooth and joyful start to school life.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Additional Information
        </Typography>
        <List sx={{ pl: 3 }}>
          <ListItem>
            • Limited hostel seats are available for both boys and girls.
          </ListItem>
          <ListItem>
            • Scholarships or fee concessions may be available for meritorious
            students (based on school policy).
          </ListItem>
          <ListItem>
            • For competitive coaching (Navodaya, RIMC, Sainik, Military), early
            registration is advised.
          </ListItem>
        </List>
      </Container>

      <CallToEnroll />
      <Footer />
    </>
  );
};

export default AdmissionProcess;
